import { create } from 'zustand';
import type { PendingPolicyAcceptance } from '@/entities/policy';

interface PolicyAcceptanceModalState {
  isOpen: boolean;
  triggeredBy: 'profile' | 'interceptor' | null;
  pending: PendingPolicyAcceptance[];
  open: (
    triggeredBy: 'profile' | 'interceptor',
    pending?: PendingPolicyAcceptance[],
  ) => void;
  close: () => void;
}

export const usePolicyAcceptanceModal = create<PolicyAcceptanceModalState>((set) => ({
  isOpen: false,
  triggeredBy: null,
  pending: [],
  open: (triggeredBy, pending = []) => set({ isOpen: true, triggeredBy, pending }),
  close: () => set({ isOpen: false, triggeredBy: null, pending: [] }),
}));
